export var PasswordSetupError;
(function (PasswordSetupError) {
    PasswordSetupError["notFound"] = "password-reset-not-found";
    PasswordSetupError["locked"] = "password-reset-locked";
})(PasswordSetupError || (PasswordSetupError = {}));
var PasswordSetupRequest = /** @class */ (function () {
    function PasswordSetupRequest(token, userId, password) {
        this.isAuthenticated = false;
        this.knownErrorCodes = Object.values(PasswordSetupError);
        this.method = 'put';
        this.path = "authentication/password/reset/".concat(encodeURIComponent(token), "?user=").concat(encodeURIComponent(userId));
        this.body = JSON.stringify({ password: password });
    }
    return PasswordSetupRequest;
}());
export { PasswordSetupRequest };
